import { render } from "./collection-content-blocks.vue?vue&type=template&id=25bdb820"
import script from "./collection-content-blocks.vue?vue&type=script&lang=js"
export * from "./collection-content-blocks.vue?vue&type=script&lang=js"

import "./collection-content-blocks.vue?vue&type=style&index=0&id=25bdb820&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__